import { render, staticRenderFns } from "./jurisdiction-get.vue?vue&type=template&id=1309e5ec&scoped=true&"
import script from "./jurisdiction-get.vue?vue&type=script&lang=js&"
export * from "./jurisdiction-get.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction-get.vue?vue&type=style&index=0&id=1309e5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309e5ec",
  null
  
)

export default component.exports